// File: frontend/src/mocks/reinsurance/riskData.js

export const mockExposureData = {
  success: true,
  data: {
    total_exposure: 1600000000,
    exposure_by_peril: {
      hurricane: 660000000,
      earthquake: 480000000,
      flood: 240000000,
      wildfire: 160000000,
      marine: 60000000
    },
    exposure_by_territory: {
      US: 800000000,
      JP: 250000000,
      CA: 150000000,
      EU: 100000000,
      NZ: 100000000,
      GLOBAL: 200000000
    },
    exposure_by_contract_type: {
      property: 1000000000,
      specialty: 350000000,
      parametric: 250000000
    },
    peak_exposures: [
      {
        peril: "hurricane",
        territory: "US",
        amount: 500000000
      },
      {
        peril: "earthquake",
        territory: "JP",
        amount: 250000000
      },
      {
        peril: "earthquake",
        territory: "US",
        amount: 150000000
      },
      {
        peril: "wildfire",
        territory: "US",
        amount: 120000000
      },
      {
        peril: "flood",
        territory: "US",
        amount: 100000000
      }
    ]
  }
};

export const mockAssessRiskResponse = {
  success: true,
  message: "Risk assessment completed successfully",
  data: {
    contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
    model_id: "mod1-2e3f-4g5h-6i7j8k9l0m1n",
    expected_loss: 1125000,
    standard_deviation: 3750000,
    tail_value_at_risk: 14250000,
    probable_maximum_loss: 12750000
  }
};

export const mockPriceRiskResponse = {
  success: true,
  message: "Risk pricing completed successfully",
  data: {
    contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
    expected_loss: 1125000,
    technical_price: 1350000,
    commercial_price: 2025000,
    rate_on_line: 13.5
  }
};

export const mockModelExposureResponse = {
  success: true,
  data: {
    contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
    exposure_data: {
      total_insured_value: 750000000,
      number_of_risks: 1500,
      average_value_per_risk: 500000,
      exposure_by_territory: {
        US: 600000000,
        CA: 150000000
      },
      exposure_by_peril: {
        hurricane: 450000000,
        earthquake: 225000000,
        flood: 75000000
      }
    },
    modeling_results: {
      expected_loss: 1125000,
      standard_deviation: 3750000,
      coefficient_of_variation: 3.33,
      exceedance_probability: {
        "1_in_10": 2250000,
        "1_in_20": 4500000,
        "1_in_50": 9000000,
        "1_in_100": 12750000,
        "1_in_250": 18000000,
        "1_in_500": 22500000,
        "1_in_1000": 27000000
      },
      tail_value_at_risk: 14250000
    }
  }
};